<template>
  <v-dialog v-model="switch_dialog" max-width="700" persistent @click:outside="close">
    <v-card>
      <v-card-title>Troca de Escala</v-card-title>
      <!-- Selecionar Funcionário -->
      <template
        v-if="select_employee && selected_event.scale_date && !selected_event.scale_date.is_swap"
      >
        <v-card-subtitle>
          <v-alert color="red lighten-2" class="white--text my-4" dense
            >Selecione um funcionario para trocar esta escala</v-alert
          >
        </v-card-subtitle>
        <v-card-text>
          <v-subheader> Lista de funcionários do setor: </v-subheader>
          <v-list max-height="400" class="overflow-y-auto">
            <template v-for="employee in employees">
              <v-list-item v-if="employee.id != user.id" :key="employee.id">
                <v-list-item-avatar>
                  <img :src="image_host + employee.profile_image" />
                </v-list-item-avatar>
                <v-list-item-content>
                  {{ employee.full_name }}
                </v-list-item-content>
                <v-list-item-action class="d-flex flex-row"
                  ><v-btn
                    color="green lighten-1"
                    class="white--text"
                    @click="selectEmployee(employee)"
                  >
                    Selecionar
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
      </template>
      <!-- Após selecionar -->
      <template v-else-if="!select_employee">
        <v-card-subtitle> </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <span class="text-h6 text-sm-h6 text-md-h5 mr-2 red--text text--lighten-1"
                >Nome:</span
              >
              <span class="text-h6 text-sm-h6 text-md-h5 mb-4">{{ employee.full_name }}</span>
              <br />
              <span class="text-h6 text-sm-h6 text-md-h5 mr-2 red--text text--lighten-1"
                >Email:</span
              >
              <span class="text-h6 text-sm-h6 text-md-h5">{{ employee.email }}</span>
              <br />
              <v-container class="d-flex justify-space-between mt-6 pa-0">
                <v-btn @click="close" color="red lighten-1" class="white--text">Cancelar</v-btn>
                <v-btn color="green lighten-1" class="white--text" @click="createSwap"
                  >Confirmar</v-btn
                >
              </v-container>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
      <!-- Caso ja tenha solicitado a troca -->
      <template
        v-else-if="
          selected_event.scale_date &&
          selected_event.scale_date.is_swap &&
          selected_event.scale_date.type == 'REQUESTER'
        "
      >
        <v-card-text>
          <v-row>
            <v-col cols="12">
              Troca já solicitada para:
              <br />
              <span class="text-h6 text-sm-h6 text-md-h5 mr-2 red--text text--lighten-1"
                >Nome:</span
              >
              <span class="text-h6 text-sm-h6 text-md-h5 mb-4">{{
                selected_event.scale_date.employee_recipient
              }}</span>
              <br />
              <span class="text-h6 text-sm-h6 text-md-h5 mr-2 red--text text--lighten-1"
                >Status:</span
              >
              <span class="text-h6 text-sm-h6 text-md-h5">{{
                selected_event.scale_date.swap_status
              }}</span>
              <br />
            </v-col>
          </v-row>
          <v-row>
            <v-container class="d-flex justify-end pa-4">
              <v-btn @click="cancelSwap" color="red lighten-1" class="white--text">Cancelar</v-btn>
            </v-container>
          </v-row>
        </v-card-text>
      </template>
      <template
        v-else-if="
          selected_event.scale_date &&
          selected_event.scale_date.is_swap &&
          selected_event.scale_date.type == 'RECIPIENT'
        "
      >
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <!-- <br /> -->
              <span class="text-h6 text-sm-h6 text-md-h5 mr-2">Você está substituindo</span>
              <span class="text-h6 text-sm-h6 red--text text-md-h5 mb-4"
                >{{ selected_event.scale_date.creator }}
              </span>
              <span class="text-h6 text-sm-h6 text-md-h5 mb-4">neste dia.</span>

              <br />
            </v-col>
          </v-row>
        </v-card-text>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import RESOURCES from '@/global/resources'

export default {
  name: 'FormSwap',
  props: {
    dialog: Boolean,
    closeDialog: Function,
    selected_event: {
      type: Object,
      default: () => {
        return { is_swap: false }
      },
    },
  },
  data: function () {
    return {
      image_host: RESOURCES.ASSETS_PROFILE_IMAGES(),
      select_employee: true,
      confirm_selection: false,
      employee: '',
    }
  },
  computed: {
    ...mapState('employees', ['employees']),
    ...mapState('auth', ['user']),
    switch_dialog() {
      return this.dialog
    },
  },
  methods: {
    ...mapActions('scales', ['ActionStoreSwap', 'ActionCancelSwap']),
    async createSwap() {
      try {
        const eventDate = new Date(this.selected_event.start)
        let month = eventDate.getMonth() + 1
        month = month == 13 ? 1 : month

        const payload = {
          scale_date_from_id: this.selected_event.scale_date.id,
          employee_id_to: this.employee.id,
          month_id: eventDate.getMonth() + 1,
        }
        await this.ActionStoreSwap(payload)
        this.$swal({
          icon: 'success',
          title: 'Solicitado',
          text: `Troca solicitada com sucesso, aguarde a resposta do funcionário e do coordenador.`,
        })
        this.closeDialog()
        this.$emit('update')
      } catch (e) {
        console.log(e)
      }
    },
    async cancelSwap() {
      try {
        await this.$swal({
          icon: 'warning',
          title: 'Atenção',
          showCancelButton: true,
          text: `Você realmente deseja cancelar a solicitação?`,
        }).then(async (response) => {
          if (response.isConfirmed) {
            await this.ActionCancelSwap(this.selected_event.scale_date.swap_id)
            this.$swal({
              icon: 'success',
              title: 'Cancelado',
              text: `Solicitação cancelada com sucesso.`,
            })
            this.close()
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    selectEmployee(employee) {
      this.employee = employee
      this.select_employee = false
    },
    close() {
      this.closeDialog()
      this.select_employee = true
      this.employee = ''
    },
  },
}
</script>
